module.exports = __webpack_public_path__ + "img/itx-file-type-oth.3884402d.svg";